import { ArrowBack } from "@mui/icons-material";
import { Box, Divider, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CircleCheckBig, MapPin } from "lucide-react";
import { resolveAssetUrl } from "../../company/helpers/ComapnyHelpers";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, ErrorScreen, Loading } from "../../../components";
import { TConcessionaria } from "../../../services";
import { useToastStore } from "../../../stores";
import { useAuthStore } from "../../../stores/auth-store";
import { colorPrimary, colorSubText } from "../../../theme";
import { moneyFormatter } from "../../../utils";
import { formatCurrencyBRL, formatDateFromISO } from "../../../utils/mask/MaskUtils";
import { addressFormatter } from "../../../utils/methods/addressFormatter";
import { SubmitButton } from "../../company/components/ButtonComponent";
import { cellStyleBold } from "../../company/components/TableColor";
import { InfoColumn } from "../components/InfoColumn";
import { CompreAgoraModal } from "../components/ModalCompreAgoraModal";
import { PropostaModal } from "../components/ModalProposta";
import { VehicleImageGallery } from "../components/VehicleImageGallery";
import { Anuncio } from "../entities/ShopkeeperEntity";
import { encerramentoAnúncio, lidarComTipoVeiculo, lidarComValorInicialOrValoProposta } from "../helpers/Helpers";
import { concessionariaMock, headerTablePropostas, iconsIconColumn } from "../mocks/ShopkeeperMocks";
import { fetchAnuncioDetails, fetchAnuncioDetailsAnonymous, fetchFipe, fetchQtdClick } from "../repository/ShopkeeperRepository";




export function AnuncioComboDetails() {
const { id } = useParams<{ id: string }>();
const { isAuthenticated } = useAuthStore();
const { setToast } = useToastStore();
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("md"));
const comboId = Number(id);
const [isLoading, setLoading] = useState<boolean>(true);
const [error, setError] = useState<boolean>(false);
const [currentTab, setCurrentTab] =useState<number>(0);
const [anuncio, setAnuncio] = useState<Anuncio | null>(null);
const [qtdClick, setQtdClick] = useState<number>(0);
const jaCarregou = useRef(false);
const fipeBuscada = useRef<Set<number>>(new Set());
const [openModal, setModalOpen] = useState(false);
const [openModalCompreAgora, setModalCompreAgoraOpen] = useState(false);
const isVendidoOrEncerrado = anuncio?.tag_status ==='1' || anuncio?.tag_status === '2';
const isCompraAgoraIndisponivel = 
  anuncio?.tipo_anuncio === "L" || anuncio?.tipo_anuncio === "C" ;

const valorCompraAgora = isCompraAgoraIndisponivel || isVendidoOrEncerrado
  ? "Compre agora indisponível"
  : `Comprar Agora por ${formatCurrencyBRL(anuncio?.compre_agora ?? 0)}`;

const tituloBotao =isVendidoOrEncerrado? "Compre agora indisponível" : valorCompraAgora;

const handleOnChagentPage =(row: number) => {
setCurrentTab(row);
};

const fetchQtdClickCombo = async (id: number) => { 
  try {
    const result = await fetchQtdClick(id);
    if (!result?.success) {
      setToast({ message: result?.message ?? "Erro. Contate o administrador", variant: 'error' });
      return;
    }
    setQtdClick(result.data ?? 0);
  } catch (error) {
    setToast({ message:"Erro. Contate o administrador", variant: 'error' });
  } finally {
    setLoading(false);
  }
}

const fetchCombo = async () => { 
  try {
    setLoading(true);
    const result = isAuthenticated ? await fetchAnuncioDetails(comboId) : await fetchAnuncioDetailsAnonymous(comboId);
    if (!result?.success) {
      setToast({ message: result?.message ?? "Erro ao buscar o combo.", variant: 'error' });
      setError(true);

      return;
    }
    setAnuncio(result.data);  
  } catch (error) {
     setToast({ message: "Erro ao buscar o combo.", variant: 'error' });
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (!anuncio || !anuncio.veiculos || anuncio.veiculos.length === 0) {
    return;
  }

  const veiculo = anuncio.veiculos[currentTab];
  if (!veiculo) return;

  const precisaBuscar =
    (veiculo.valor_fipe === undefined || veiculo.valor_fipe === null || veiculo.valor_fipe === "0" || veiculo.valor_fipe === "NaN")
    && !fipeBuscada.current.has(veiculo.id);

  if (!precisaBuscar || !veiculo.codigo_fipe || !veiculo.ano_modelo) {
    return;
  }

  fipeBuscada.current.add(veiculo.id);

  const codigoFipe = veiculo.codigo_fipe;
  const anoModelo = veiculo.ano_modelo;
  const buscarFipe = async () => {
    const valorFipe = await fetchFipe(
      codigoFipe,
      Number(anoModelo)
    );
    
    if (valorFipe !== null) {
      setAnuncio(prev => prev ? { ...prev, veiculos: prev.veiculos.map(v => v.id === veiculo.id ? { ...v, valor_fipe: valorFipe } : v) } : null);
    }
  };

  buscarFipe();
}, [currentTab, anuncio]);


useEffect(()=> {
  if (jaCarregou.current) return;
  jaCarregou.current = true;
  const fetchData = async ()=> {
    setLoading(true);
  await fetchCombo();
  await fetchQtdClickCombo(comboId);
  // await handleFetchFipe();
     setLoading(false);
  };
  fetchData();
},);





    if (isLoading) return <Loading fullScreen={true}/>;
    if (error) return <ErrorScreen fullScreen={true} />;
    return (
      <>
    <PropostaModal 
    onSuccess={async (message) => {
    setToast({ message: message, variant: 'success' });
    await fetchCombo();
  }}
    tipo_anuncio={anuncio?.tipo_anuncio??""}
    data_inicio={anuncio?.data_inicio??""}
    onClose={()=> setModalOpen(false)} 
    combo_id={comboId}
    open={openModal} 
    val_minimoProposta={anuncio?.melhor_oferta !==null? anuncio!.melhor_oferta!+200 : anuncio!.melhor_oferta! }/>

    <CompreAgoraModal
    onSuccess={async (message) => {
    setToast({ message: message, variant: 'success' });
    await fetchCombo();
  }}
    val_compre_agora={anuncio?.compre_agora??0}
    tipo_anuncio={anuncio?.tipo_anuncio??""}
    data_inicio={anuncio?.data_inicio??""}
    onClose={()=> setModalCompreAgoraOpen(false)} 
    combo_id={comboId}
    open={openModalCompreAgora} 
    val_minimoProposta={anuncio?.melhor_oferta !==null? anuncio!.melhor_oferta!+200 : anuncio!.melhor_oferta! }
    />

    <Box  height={"100vdh"} width="100vdw" display={"flex"} flexDirection={"column"}>
    <Link to="/anuncios">
        <Button variant="text">
          <ArrowBack fontSize="inherit" />
          <span>Voltar para os anúncios</span>
        </Button>
    </Link>
    <Box
      display="grid"
      gridTemplateColumns={isMobile ? "1fr" : "2fr 1fr"}
      gap={2}
      mt={2}
      alignItems="stretch"
    >
      {/* Container da esquerda (mais largo) */}
      <Box display={"flex"} flexDirection={"column"} minWidth={0} minHeight={0} maxHeight={1400} order={isMobile ? 0 : 1} >
        <Box
          display="flex"
          flexDirection="column"
          bgcolor="white"
          p={2}
          borderRadius={2}
          minWidth={0}
        >
          {/* HEADER */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography fontWeight={600} fontSize="1.45rem">
                Combo com {anuncio?.veiculos.length ?? 0} veículos
              </Typography>
              <Typography fontWeight={600} fontSize="0.95rem" color={colorSubText}>
                { anuncio !== null? lidarComTipoVeiculo(anuncio?.tipo_anuncio ?? '', anuncio?.tipo_anuncio ==="L" ? anuncio.data_leilao :  anuncio?.data_finalizacao ?? "", anuncio.tag_status ?? "" ): ''}
              </Typography>
            </Box>

            <Typography fontWeight={600} fontSize="0.95rem" color={colorSubText}>
              Visualizações: {qtdClick}
            </Typography>
          </Stack>

          {/* TABS */}
          <Stack direction="row" mt={4} gap={2} mb={2} maxWidth={"100%"} overflow={"auto"}>
            {anuncio?.veiculos.map((item, index) => (
              <Box
                key={index}
                minWidth={isMobile ? 120 : "auto"}
                onClick={() => handleOnChagentPage(index)}
                sx={{
                  width: "20%",
                  cursor: "pointer",
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: currentTab === index ? "100%" : "0%",
                    height: "2px",
                    background:
                      "linear-gradient(to right, #f59f0a 0%, #e68a00 100%)",
                    transition: "0.25s ease",
                  },
                  "&:hover::after": {
                    width: "100%",
                  },
                }}
              >
                <Typography
                  fontSize="0.85rem"
                  fontWeight={currentTab === index ? 600 : 400}
                  color={currentTab === index ? "black" : "#94a3b8"}
                >
                  {item.marca ?? ""} {item.modelo ?? ""}
                </Typography>
              </Box>
            ))}
          </Stack>
            {/* IMAGEM PRINCIPAL */}
          <VehicleImageGallery images={anuncio?.veiculos[currentTab].fotos?.map((f) => f.urL_FOTO)??[]} autoScroll  idAnuncio={Number(id)}/>
          </Box>
          <Box
          display="flex"
          flexDirection="column"
          bgcolor="white"
          p={4}
          borderRadius={2}
          minWidth={0}
          height={"100%"}
          mt={4}
        >
          <Typography fontWeight={600} fontSize={"1.3rem"} mb={2}>
            Informações do anúncio
          </Typography>
          <Typography fontWeight={400} fontSize={"1rem"} >
           {anuncio?.texto_padrao}
          </Typography>
          </Box>
      </Box>

      {/* Container da direita (mais estreito) */}
      <Box display={"flex"} flexDirection={"column"} minWidth={0} minHeight={0} gap={3} maxHeight={1400} order={isMobile ? 0 : 1}> 
          <Box minWidth={0} minHeight={0} borderRadius={2} bgcolor={"white"} alignContent={"center"} alignItems={"center"} justifyContent={"center"} justifyItems={"center"} pt={2} pb={2}>
              <SubmitButton type="button"maxWidth={250}onClick={() => { if (!isAuthenticated) { setToast({ message: "Você precisa estar logado para comprar. Faça login para continuar.", variant: 'error' }); return; } setModalCompreAgoraOpen(true); }}disabled={isCompraAgoraIndisponivel || isVendidoOrEncerrado}title={tituloBotao}/>
          </Box>
          <Box minWidth={0} minHeight={0} borderRadius={2} bgcolor={"white"} alignContent={"start"} alignItems={"start"} justifyContent={"start"} justifyItems={"start"} pt={2} pb={2} pl={3} pr={3}>
              <Typography fontWeight={600} color={"black"} fontSize={"1.4rem"}>Para venda</Typography>
              <Typography fontWeight={600} color={colorSubText} fontSize={"1.2rem"}>Maior valor ofertado</Typography>
              <Typography fontWeight={600} color={colorPrimary} fontSize={"1.4rem"} mb={2}>{anuncio?.melhor_oferta!==null?  lidarComValorInicialOrValoProposta(anuncio!.melhor_oferta, anuncio?.melhor_oferta) : ""}</Typography>
              <Typography fontWeight={600} color={colorSubText} fontSize={"1.2rem"}>{anuncio?.tag_status ==='1'? 'Anuncio vendido': anuncio?.tag_status ==='2'? 'Anúncio Encerrado' :'Encerramento do anúncio '}</Typography>
              <Typography fontWeight={600} color={anuncio?.tag_status ==='1' || anuncio?.tag_status ==='2'?"transparent" :"black"} fontSize={"1.2rem"}>{encerramentoAnúncio(anuncio!.tipo_anuncio!, anuncio!.data_finalizacao)}</Typography>
              <Stack display={"flex"} flexDirection={"row"} width={"100%"} minWidth={0} minHeight={0} alignContent={"center"} justifyContent={"center"} alignItems={"center"} justifyItems={"center"} mt={4.5} mb={4}>
                <SubmitButton type="button" disabled={isLoading || isVendidoOrEncerrado} title="Fazer proposta" maxWidth={isMobile ? 150 : 250}
                onClick={ async ()=>{ if (!isAuthenticated) { setToast({ message: "Você precisa estar logado para fazer uma proposta. Faça login para continuar.", variant: 'error' }); return; } setModalOpen(true); }}/>
              </Stack>
              <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
              <Typography fontWeight={600} color={colorSubText} fontSize={"1.2rem"}>Tabela de lances</Typography>
              <Box minHeight={185} maxHeight={185} width={"100%"} minWidth={0} display={"flex"}>
                    <TableContainer
                    sx={{
                    maxHeight: "100%",
                    minHeight: "0",
                    minWidth: "0",
                    width: "100%",
                    overflowY: "auto",
                    }}
                    >
                    <Table
                    size={isMobile ? "small" : "medium"}
                    sx={{
                    bgcolor: "transparent",
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                    }}
                    >
                    {/* HEADER */}
                    <TableHead>
                    <TableRow>
                    {headerTablePropostas.map(
                    (i) => (
                    <TableCell
                    key={i.id}
                    sx={{
                    backgroundColor: "transparent",
                    color: colorSubText,
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    borderBottom: "1px solid rgba(40, 61, 107, 0.4)",
                    }}
                    >
                      <Stack display={"flex"} flexDirection={"row"} minHeight={0} minWidth={0} maxWidth={"100%"} alignContent={"center"} justifyContent={"center"} alignItems={"center"} justifyItems={"center"} gap={0.5}>
                        {i.icon}
                        {i.label}
                      </Stack>
                    </TableCell>
                    )
                    )}
                    </TableRow>
                    </TableHead>

                  <TableBody>
                    {anuncio?.propostas.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          sx={{
                            textAlign: "center",
                            py: 4,
                          }}
                        >
                          <Typography
                            fontSize="1rem"
                            fontWeight={500}
                            color={colorSubText}
                          >
                            Nenhuma proposta realizada até o momento.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      anuncio?.propostas.map((row, index) => (
                        <TableRow
                          key={`-${index}`}
                          sx={{
                            backgroundColor: "rgba(255,255,255,0.02)",
                            transition: "all 0.25s ease",
                          }}
                        >
                          <TableCell sx={{...cellStyleBold,fontSize: isMobile ? "0.75rem" : "0.9rem" }}>
                            {moneyFormatter(row.val_proposta)}
                          </TableCell>

                         <TableCell sx={{...cellStyleBold,fontSize: isMobile ? "0.75rem" : "0.9rem" }}>
                            {row.usuario}
                          </TableCell>

                          <TableCell sx={{...cellStyleBold,fontSize: isMobile ? "0.75rem" : "0.9rem" }}>
                            {formatDateFromISO(row.data_cadastro)}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>


                    </Table>
                    </TableContainer>
              </Box>
          </Box>
          <Box minWidth={0} minHeight={0}  borderRadius={2} bgcolor={"white"} alignContent={"start"} alignItems={"start"} justifyContent={"start"} justifyItems={"start"} pt={2} pb={2} pl={3} pr={3}>
            <Typography fontWeight={600} fontSize={"1.6rem"}>Anunciante</Typography>
            <Stack display={"flex"} flexDirection={"row"} minWidth={0} minHeight={0} alignContent={"center"} justifyContent={"center"} alignItems={"center"} justifyItems={"center"} gap={3} mt={2}>
              <Box
              component="img"
              src={`https://canaldorepasse.com.br/cadastros/fotos/concessionaria/${anuncio?.id_concesionaria}/${anuncio?.logo}`}
              decoding="async"
              loading="eager"
              alt="Imagem do veículo"
              sx={{
                width: "64px",
                height: "76px",
                objectFit: "contain",
                display: "block",
              }}
              />
            <Typography fontSize={"1.4rem"} fontWeight={600} minWidth={0} minHeight={0}>{anuncio?.concessionaria}</Typography>
            </Stack>
            <Stack display={"flex"} flexDirection={"row"} minWidth={0} minHeight={0} alignContent={"center"} justifyContent={"center"} alignItems={"center"} justifyItems={"center"} gap={1} mt={2}>
              <MapPin color={colorPrimary}/>
              <Typography fontSize={"0.85rem"} color={colorSubText} fontWeight={600} minWidth={0} minHeight={0}>{`${anuncio?.logradouro?.trim()}. ${anuncio?.numero?.trim()}${anuncio?.complemento?.trim()} - ${anuncio?.bairro}, ${anuncio?.cidade} - ${anuncio?.uf?.trim()}`}</Typography>
            </Stack>
                <iframe
                  width="100%"
                  height={isMobile ? 200 : 300}
                  src={`https://www.google.com/maps?q=${addressFormatter(
                    concessionariaMock as TConcessionaria
                  )}&output=embed`}
                  style={{ border: '0' }}
                  allowFullScreen
                  loading='lazy'
                  referrerPolicy='no-referrer-when-downgrade'
                  title='Google Maps'
                ></iframe>
          </Box>
      </Box>
    </Box>
    <Typography fontSize={"1.4rem"} fontWeight={600} mt={6}>Sobre o veículo</Typography>
    <Box
      display="grid"
      gridTemplateColumns={isMobile ? "1fr" : "2fr 1fr"}
      gap={2}
    >
      {/* Container da esquerda (mais largo) */}
      <Box display={"flex"} flexDirection={"column"} minWidth={0} minHeight={0} mb={4} mt={0}> 
        <Box display={"flex"} flexDirection={"column"} minWidth={0} maxWidth={"100%"} minHeight={250} maxHeight={250} bgcolor={"white"} borderRadius={2} p={2} mt={2}>
        <Typography fontWeight={600} fontSize={"1.4rem"}>Observações</Typography>
        <Typography fontWeight={300} fontSize={"0.95rem"}>{anuncio?.veiculos[currentTab].observacao?.trim()?? "Sem informações"}</Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} minWidth={0} maxWidth={"100%"} minHeight={250} maxHeight={250} bgcolor={"white"} borderRadius={2} p={2} mt={2}>
        <Typography fontWeight={600} fontSize={"1.4rem"}>Avarias</Typography>
        <Typography fontWeight={300} fontSize={"0.95rem"}>{anuncio?.veiculos[currentTab].avarias?.trim()?? "Sem avarias"}</Typography>
        </Box>
      </Box>
      {/* Container da direita (mais estreito) */}
      <Box display={"flex"} flexDirection={"column"} minWidth={0} minHeight={0} mb={4} mt={0}> 
         <Box display={"flex"} flexDirection={"column"} minWidth={0} maxWidth={"100%"} minHeight={518} maxHeight={518} bgcolor={"white"} borderRadius={2} p={2} mt={2}>
          <Typography fontWeight={600} fontSize={"1.4rem"} mb={2}>Dados do veículo</Typography>
        <Box
          display="grid"
          gap={4}
          gridTemplateColumns={isMobile ? "1fr" : "repeat(2, 1fr)"}
          alignItems="center"
        >
          <InfoColumn
            icon={iconsIconColumn.plate}
            label="Placa"
            value={anuncio?.veiculos[currentTab].placa ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.engine}
            label="Motor"
            value={anuncio?.veiculos[currentTab].motor ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.mileage}
            label="Quilometragem"
            value={anuncio?.veiculos[currentTab].km ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.transmission}
            label="Transmissão"
            value={anuncio?.veiculos[currentTab].transmissao ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.year}
            label="Ano"
            value={`${anuncio?.veiculos[currentTab].ano_fabricacao ?? ""}/${anuncio?.veiculos[currentTab].ano_modelo ?? ""}`}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.fuel}
            label="Combustível"
            value={anuncio?.veiculos[currentTab].combustivel ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.color}
            label="Cor"
            value={anuncio?.veiculos[currentTab].cor ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.doors}
            label="Portas"
            value={anuncio?.veiculos[currentTab].portas ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.fipeCode}
            label="Código FIPE"
            value={anuncio?.veiculos[currentTab].codigo_fipe ?? '---'}
            labelColor={colorSubText}
          />

          <InfoColumn
            icon={iconsIconColumn.fipeValue}
            label="Valor FIPE"
            value={anuncio?.veiculos[currentTab].valor_fipe?? 0}
            labelColor={colorSubText}
          />
        </Box>

        </Box>
      </Box>
    </Box>
    <Box
      display="grid"
      gridTemplateColumns={isMobile ? "1fr" : "2fr 1fr"}
      gap={2}
    >
      <Box display={"flex"} flexDirection={"column"} minWidth={0} minHeight={0} mb={4} mt={0} bgcolor={"white"} p={2} borderRadius={2}>
        <Typography fontWeight={600} fontSize={"1.4rem"}>Acessórios</Typography>
        <Box
        minHeight={0}
        minWidth={0}
        mt={4}
        overflow={"auto"}
        maxWidth={"100%"}
        maxHeight={"100%"}
          display="grid"
          gap={2}
          gridTemplateColumns={isMobile ? "1fr" : "repeat(3, 1fr)"}
          alignItems="center"
        >
        {anuncio?.veiculos[currentTab]?.acessorios?.map((item, index) => (
          <Stack key={index} flexDirection="row" display={"flex"} alignItems="center" gap={1}>
            <CircleCheckBig color={colorPrimary} size={18}/>
            <Typography fontWeight={500} color={colorSubText} fontSize={"0.95rem"}>
              {item.acessorio}
            </Typography>
          </Stack>
        ))}
        </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} minWidth={0} minHeight={0} mb={4} mt={0}   borderRadius={2}>
        <Box display={"flex"} flexDirection={"column"} minWidth={0} maxWidth={"100%"} minHeight={150} maxHeight={150} bgcolor={"white"} borderRadius={2} p={2}  alignItems={"start"} justifyContent={"start"} >
          <Typography fontWeight={600} fontSize={"1.4rem"} >Laudo técnico</Typography>
            <a
            href={resolveAssetUrl(anuncio?.veiculos[currentTab]?.laudo ?? "", anuncio?.veiculos[currentTab]?.id ?? "")}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", paddingTop:5 }}
          >
          <Box display="flex" flexDirection="column">
            <Typography
              fontWeight={400}
              fontSize="1rem"
              color={colorPrimary}
              sx={{
                cursor: "pointer",
                display: "inline-block",
                transformOrigin: "center",
                animation: "scalePulse 1.4s ease-in-out infinite",
                "@keyframes scalePulse": {
                  "0%": { transform: "scale(1)" },
                  "50%": { transform: "scale(1.06)" },
                  "100%": { transform: "scale(1)" },
                },
              }}
            >
              Clique aqui
            </Typography>

            <Divider
              sx={{
                width: "100%",
                my: 0,
                borderBottomWidth: 2,
                color: colorPrimary,
                bgcolor: colorPrimary,
              }}
            />
          </Box>
          </a>
        </Box>
      </Box>
    </Box>
    </Box>
    </>
    );

}